module.exports = __webpack_public_path__ + "img/background-todos-mobile.3c0701d3.png";